import { FC } from "react";
import React from "react";

import { t } from "@helpers/translate";
import { plural } from "@helpers/plural";
import { BookingProvider } from "@graphql/types";

interface Props {
  adults: number;
  infants: number;
  child: number;
}

export const PeopleInfo: FC<Props> = ({ adults, infants, child }) => {
  return (
    <h3 className="text-gray-500 text-left">
      {getReadablePeopleValue(adults, child, infants)}
    </h3>
  );
};

export function getReadablePeopleValue(
  adults: number,
  child: number,
  infants: number,
  provider?: BookingProvider
) {
  if (!adults && !child && !infants) {
    return "--";
  }

  if (provider === BookingProvider.Mozio) {
    const people = adults + child + infants;
    return `${people} ${people > 1 ? "People" : "Person"}`;
  }

  const peopleValue =
    adults > 0
      ? plural(adults, {
          one: t({
            id: "auth.bookings.adult",
            message: `${adults} Adult`,
          }),
          other: t({
            id: "auth.bookings.adults",
            message: `${adults} Adults`,
          }),
        })
      : undefined;

  const childrenValue =
    child > 0
      ? plural(child, {
          one: t({
            id: "auth.bookings.child",
            message: `${child} Child`,
          }),
          other: t({
            id: "auth.bookings.children",
            message: `${child} Children`,
          }),
        })
      : undefined;

  const infantsValue =
    infants > 0
      ? plural(infants, {
          one: t({
            id: "auth.bookings.infant",
            message: `${infants} Infant`,
          }),
          other: t({
            id: "auth.bookings.infants",
            message: `${infants} Infants`,
          }),
        })
      : undefined;

  return `${peopleValue}${childrenValue ? "," : ""} ${
    childrenValue ? childrenValue : ""
  }${infantsValue ? "," : ""} ${infantsValue ? infantsValue : ""}`;
}
